// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Table.AddonTable {
  --border: 1px solid rgba(0, 0, 0, 0.15);
  width: 100%;
  min-height: calc(100vh - var(--header-height));
}
.Table.AddonTable table {
  --sp-table-header-bg: var(--bs-secondary-subtle);
  background-color: #fff;
  border-width: 1px 0;
}
.Table.AddonTable table .TableRow {
  display: grid;
  grid-template-columns: 3rem 9rem 14rem 14rem 16rem minmax(6rem, 0.8fr) minmax(6rem, 1.2fr) 9rem 5rem;
  width: 100%;
}
.Table.AddonTable table .TableRow + .TableRow {
  border-top: var(--border);
}
.Table.AddonTable table .TableRow.TableRow-Header {
  border-bottom: var(--border);
}
.Table.AddonTable table .TableRow.TableRow-Header .TableCell-Content {
  display: flex;
  justify-content: center;
  align-items: center;
}
.Table.AddonTable table .TableRow.focused:not(.focused ~ .focused) {
  background-color: #e3f9ff;
}
.Table.AddonTable table .TableRow.focused:not(.focused ~ .focused) .TableCell {
  background-color: #e3f9ff;
}
.Table.AddonTable table .TableRow .TableCell + .TableCell {
  border-left: var(--border);
}
.Table.AddonTable table .TableRow .TableCell .TableCell-Content {
  padding: 0.35rem;
  align-content: center;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
}
.Table.AddonTable table .TableRow .TableCell .TableCell-Content .SwitchInput {
  justify-content: center;
}
.Table.AddonTable table .TableRow .TableCell.NOT_PARSED {
  background-color: rgba(255, 186, 186, 0.65);
}
.Table.AddonTable table .TableRow .TableCell.PARSED {
  background-color: rgba(255, 158, 22, 0.3);
}
.Table.AddonTable table .TableRow .TableCell.POTENTIAL, .Table.AddonTable table .TableRow .TableCell.STAGED {
  background-color: rgba(25, 135, 84, 0.25);
}`, "",{"version":3,"sources":["webpack://./src/features/Addons/components/AddonTable/styles.scss"],"names":[],"mappings":"AAEA;EACE,uCAAA;EACA,WAAA;EACA,8CAAA;AADF;AAGE;EACE,gDAAA;EACA,sBAAA;EACA,mBAAA;AADJ;AAGI;EACE,aAAA;EACA,oGACE;EASF,WAAA;AAVN;AAWM;EACE,yBAAA;AATR;AAYM;EACE,4BAAA;AAVR;AAWQ;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AATV;AAaM;EACE,yBAAA;AAXR;AAaQ;EACE,yBAAA;AAXV;AAgBQ;EACE,0BAAA;AAdV;AAgBQ;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAdV;AAeU;EACE,uBAAA;AAbZ;AAgBQ;EACE,2CAAA;AAdV;AAiBQ;EACE,yCAAA;AAfV;AAkBQ;EAEE,yCAAA;AAjBV","sourcesContent":["@import '../../../../globals.scss';\n\n.Table.AddonTable {\n  --border: 1px solid rgba(0, 0, 0, 0.15);\n  width: 100%;\n  min-height: calc(100vh - var(--header-height));\n\n  table {\n    --sp-table-header-bg: var(--bs-secondary-subtle);\n    background-color: #fff;\n    border-width: 1px 0;\n\n    .TableRow {\n      display: grid;\n      grid-template-columns: // COLUMN WIDTHS\n        3rem // SELECT\n        9rem // DATE\n        14rem // STATUS\n        14rem // PROVIDER\n        16rem // IMPORTED-BY\n        minmax(6rem, 0.8fr) // FROM\n        minmax(6rem, 1.2fr) // SUBJECT\n        9rem // TYPE\n        5rem; // DOWNLOAD\n      width: 100%;\n      + .TableRow {\n        border-top: var(--border);\n      }\n\n      &.TableRow-Header {\n        border-bottom: var(--border);\n        .TableCell-Content {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n        }\n      }\n\n      &.focused:not(.focused ~ .focused) {\n        background-color: #e3f9ff;\n\n        .TableCell {\n          background-color: #e3f9ff;\n        }\n      }\n\n      .TableCell {\n        + .TableCell {\n          border-left: var(--border);\n        }\n        .TableCell-Content {\n          padding: 0.35rem;\n          align-content: center;\n          text-align: center;\n          white-space: nowrap;\n          overflow: hidden;\n          text-overflow: ellipsis;\n          font-weight: 700;\n          .SwitchInput {\n            justify-content: center;\n          }\n        }\n        &.NOT_PARSED {\n          background-color: rgba(255, 186, 186, 0.65); // RED\n        }\n\n        &.PARSED {\n          background-color: rgba(255, 158, 22, 0.3); // ORANGE\n        }\n\n        &.POTENTIAL,\n        &.STAGED {\n          background-color: rgba(25, 135, 84, 0.25); // GREEN;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
